function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "e8b3895b-4c71-4a82-99a7-7f8ed88a37c3",
  x1: 1008.99,
  y1: 560.76,
  x2: 1158.99,
  y2: 560.76,
  gradientTransform: "matrix(0, -1, -1, 0, 660.46, 1183.99)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#ffd0d0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#ff5b5b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff5151"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "babfe20e-ff33-43cf-95b2-bdf0f3486be6",
  x1: 99.7,
  y1: 106.9,
  x2: 99.7,
  y2: 177,
  gradientTransform: "matrix(1, 0, 0, -1, 0, 202)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#F8F9FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F8F9FC",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bee9d137-b7d4-4901-89df-7c6e85dd46a6",
  x1: 99.7,
  y1: 145,
  x2: 99.7,
  y2: 103,
  gradientTransform: "matrix(1, 0, 0, -1, 0, 202)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#fffcfc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#fff1f1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#ffdfdf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#ffc6c6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffb6b6"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "a783c386-0b8a-4edd-8697-9e310afe210e",
  x1: 99.65,
  y1: 97.3,
  x2: 99.65,
  y2: 45,
  gradientTransform: "matrix(1, 0, 0, -1, 0, 202)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fe5050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c6000f"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b6712ac1-b0f6-40a4-81c3-42c8cf3f2b0d",
  x1: 79.47,
  y1: 103.38,
  x2: 125.3,
  y2: 117.51,
  xlinkHref: "#a783c386-0b8a-4edd-8697-9e310afe210e"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b27a6947-520f-4cbf-a5e4-48b44a2c03b2",
  x1: 98.01,
  y1: 114.71,
  x2: 109.96,
  y2: 118.4,
  xlinkHref: "#a783c386-0b8a-4edd-8697-9e310afe210e"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f2e30c2b-22dd-4c93-adb0-c2c523b7029a",
  x1: 49.73,
  y1: 134.6,
  x2: 60.44,
  y2: 134.6,
  gradientTransform: "matrix(1, 0, 0, -1, 0, 202)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fe5050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ed1828"
})));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 200,
  height: 200,
  fill: "none",
  opacity: 0
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 99.7,
  cy: 100,
  r: 75,
  fill: "#ffb6b6"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M75.2,95.1,124.4,94l7.4-61.8a75.16,75.16,0,0,0-64.2,0Z",
  fill: "url(#babfe20e-ff33-43cf-95b2-bdf0f3486be6)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M150.8,99H48.6a4.91,4.91,0,0,1-4.9-4.9V61.9A4.91,4.91,0,0,1,48.6,57H150.8a4.91,4.91,0,0,1,4.9,4.9V94.1A4.91,4.91,0,0,1,150.8,99Z",
  fill: "#fff"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 49.7,
  y: 83,
  width: 100,
  height: 3,
  fill: "#ffd7d7"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 65.7,
  y: 63,
  width: 19,
  height: 2,
  fill: "#ff5151"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 65.7,
  y: 67,
  width: 19,
  height: 2,
  fill: "#ff5151"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 65.7,
  y: 71,
  width: 19,
  height: 2,
  fill: "#ffd7d7"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 49.7,
  y: 78,
  width: 100,
  height: 3,
  fill: "#ffd7d7"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 49.7,
  y: 92,
  width: 14,
  height: 2,
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 65.7,
  y: 92,
  width: 6,
  height: 2,
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 108.3,
  cy: 51.6,
  r: 2.4,
  fill: "#fff"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 80.2,
  cy: 42.6,
  r: 1.5,
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 120,
  cy: 34,
  r: 1.5,
  fill: "#fff"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M144.7,132.8h-1.8V131a1.3,1.3,0,0,0-2.6,0v1.8h-1.8a1.3,1.3,0,0,0,0,2.6h1.8v1.8a1.3,1.3,0,0,0,2.6,0v-1.8h1.8a1.32,1.32,0,0,0,1.3-1.3A1.26,1.26,0,0,0,144.7,132.8Z",
  fill: "#fff"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M61.2,122.1H60v-1.2a.9.9,0,1,0-1.8,0v1.2H57a.9.9,0,1,0,0,1.8h1.2v1.2a.9.9,0,0,0,1.8,0v-1.2h1.2a.9.9,0,0,0,0-1.8Z",
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M114.1,157H85.4a4,4,0,0,1-3.9-3.4l-5.9-48.9h48.1l-5.9,48.9A3.64,3.64,0,0,1,114.1,157Z",
  fill: "url(#a783c386-0b8a-4edd-8697-9e310afe210e)"
});

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  points: "123.4 108.1 76.1 108.1 76.1 108.6 123.3 108.6 123.4 108.1",
  fill: "#ffb6b6"
});

var _ref21 = /*#__PURE__*/React.createElement("polygon", {
  points: "118.1 152.5 81.4 152.5 81.5 153 118 153 118.1 152.5",
  fill: "#ffb6b6"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M127,94.4,112.6,90h-.1L95.2,84.7h0L80.6,80.2a2.93,2.93,0,0,0-3.7,2l-1.3,4.2,52,16,1.3-4.2A3,3,0,0,0,127,94.4Z",
  fill: "url(#b6712ac1-b0f6-40a4-81c3-42c8cf3f2b0d)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M100.3,85.6a4,4,0,0,1,4.6-1.9,4.12,4.12,0,0,1,2.8,4.2l3.1.9a7.12,7.12,0,0,0-13.5-4.2Z",
  fill: "url(#b27a6947-520f-4cbf-a5e4-48b44a2c03b2)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M56.3,66.8a2.65,2.65,0,0,0,1.4-2.4,2.59,2.59,0,0,0-2.4-2.5,2.55,2.55,0,0,0-2.7,2.6A2.74,2.74,0,0,0,54,66.8c.1,0,0,.1,0,.1a5.27,5.27,0,0,0-4.1,5.2v.5a.32.32,0,0,0,.3.3H60.4a.32.32,0,0,0,.3-.3v-.5a5.37,5.37,0,0,0-4.1-5.2C56.2,67,56.2,66.9,56.3,66.8Z",
  fill: "url(#f2e30c2b-22dd-4c93-adb0-c2c523b7029a)"
});

var SvgRemoveCustomer = function SvgRemoveCustomer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b6c8f9b8-7221-4ce0-b498-7bd1bb6c327a",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, /*#__PURE__*/React.createElement("circle", {
    cx: 99.7,
    cy: 100,
    r: 75,
    opacity: 0.5,
    fill: "url(#e8b3895b-4c71-4a82-99a7-7f8ed88a37c3)",
    style: {
      isolation: "isolate"
    }
  }), _ref5, _ref6, /*#__PURE__*/React.createElement("path", {
    d: "M150.8,99H48.6a4.91,4.91,0,0,1-4.9-4.9V61.9A4.91,4.91,0,0,1,48.6,57H150.8a4.91,4.91,0,0,1,4.9,4.9V94.1A4.91,4.91,0,0,1,150.8,99Z",
    opacity: 0.6,
    fill: "url(#bee9d137-b7d4-4901-89df-7c6e85dd46a6)",
    style: {
      isolation: "isolate"
    }
  }), _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, /*#__PURE__*/React.createElement("path", {
    d: "M89.1,148.6h0a2.08,2.08,0,0,1-2.1-1.9l-2.8-32.5a2.16,2.16,0,0,1,2.1-2.3h0a2.08,2.08,0,0,1,2.1,1.9l2.8,32.5A2.1,2.1,0,0,1,89.1,148.6Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.4,148.6h0a2.1,2.1,0,0,1-2.1-2.3l2.8-32.5a2.08,2.08,0,0,1,2.1-1.9h0a2.1,2.1,0,0,1,2.1,2.3l-2.8,32.5A2.08,2.08,0,0,1,110.4,148.6Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7,148.6h0a2.05,2.05,0,0,1-2.1-2.1V114.1a2.05,2.05,0,0,1,2.1-2.1h0a2.05,2.05,0,0,1,2.1,2.1v32.4A2.05,2.05,0,0,1,99.7,148.6Z",
    fill: "#fff",
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _ref20, _ref21, _ref22, _ref23, _ref24);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRemoveCustomer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/remove-customer.8afa74b3.svg";
export { ForwardRef as ReactComponent };